import React from 'react';

import styled from 'styled-components';

import {getContentType} from 'app/utils/content-type';
import {gt} from 'app/utils/i18n';

import {DocumentAlertBox} from './DocumentAlertBox';

import type {VersionableDocumentTypes} from 'app/general/types';

interface Props {
  contentType: VersionableDocumentTypes;
  editDocumentUrl: string;
}

export const DocumentVersionLocked = ({
  contentType,
  editDocumentUrl,
}: Props) => {
  const ct = getContentType(contentType).name;
  const editDocumentLink = (
    <a href={editDocumentUrl}>{gt('Most recent draft')}</a>
  );
  return (
    <div className="container">
      <div className="row">
        <StyledFloatingAlertDiv>
          <DocumentAlertBox
            type="danger"
            className="position-fixed"
            icon="fa-exclamation-triangle"
            title={gt('This %(ct)s version is not editable', {
              ct,
            })}
            content={
              <div>
                {gt(
                  'The %(ct)s may still be edited by following this link %(editDocumentLink)s',
                  {
                    ct,
                    editDocumentLink,
                  }
                )}
              </div>
            }
          />
        </StyledFloatingAlertDiv>
      </div>
    </div>
  );
};

const StyledFloatingAlertDiv = styled.div.attrs({className: 'col-12'})`
  z-index: 1;
`;
